import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { option_type, class_type, record_type, bool_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Searcher__Target_4B4D257A, SearchConfig, Highlighting, CaseMatching, Searcher_$ctor_Z1481DE65, MatchType, SearchTargetResult_$reflection, SearchTarget_$reflection } from "../Search.js";
import { singleton as singleton_1, ofArray, exists } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { curry2, createObj, comparePrimitives, compare, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { FSharpSet__get_Count, FSharpSet__Contains, ofSeq, empty } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { unwrap, toArray as toArray_1, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Option_ofNonNullOrWhitespace } from "../Shopfoo.Common/Common.js";
import { iterate, append, empty as empty_1, singleton, collect, delay as delay_1, toList, map, sortBy, toArray } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { $007CNullOrWhiteSpace$007C_$007C, toKebab } from "../Shopfoo.Common/String.js";
import { join, interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { JS_runAfter } from "../UI.js";
import { op_PlusPlus } from "../fable_modules/Feliz.DaisyUI.5.0.0/Operators.fs.js";
import { SearchBox_SearchBox_3A9FAC5 } from "./SearchBox.js";
import { CheckboxState_CheckedIf_Z1FBCCD16, Checkbox_Checkbox_Z1659CCBA, CheckboxState } from "./Checkbox.js";
import { AppTranslations__get_Home, TranslationPages_Home__get_SelectedPlural } from "../Shopfoo.Shared/Translations.js";
import { Highlight_matches } from "./Highlight.js";

export class SearchInfo extends Record {
    constructor(SearchTerm, NoExactMatches) {
        super();
        this.SearchTerm = SearchTerm;
        this.NoExactMatches = NoExactMatches;
    }
}

export function SearchInfo_$reflection() {
    return record_type("Shopfoo.Client.Components.SearchInfo", [], SearchInfo, () => [["SearchTerm", string_type], ["NoExactMatches", bool_type]]);
}

export const SearchInfoModule_empty = new SearchInfo("", false);

export class SelectItem$1 extends Record {
    constructor(Value, Image, Text$, Selected, Filterable, SearchTarget) {
        super();
        this.Value = Value;
        this.Image = Image;
        this.Text = Text$;
        this.Selected = Selected;
        this.Filterable = Filterable;
        this.SearchTarget = SearchTarget;
    }
}

export function SelectItem$1_$reflection(gen0) {
    return record_type("Shopfoo.Client.Components.SelectItem`1", [gen0], SelectItem$1, () => [["Value", gen0], ["Image", option_type(class_type("Fable.React.ReactElement", undefined))], ["Text", string_type], ["Selected", bool_type], ["Filterable", bool_type], ["SearchTarget", SearchTarget_$reflection()]]);
}

class SearchedItem$1 extends Record {
    constructor(Key, Item, SearchResult) {
        super();
        this.Key = Key;
        this.Item = Item;
        this.SearchResult = SearchResult;
    }
}

function SearchedItem$1_$reflection(gen0) {
    return record_type("Shopfoo.Client.Components.SearchedItem`1", [gen0], SearchedItem$1, () => [["Key", string_type], ["Item", SelectItem$1_$reflection(gen0)], ["SearchResult", SearchTargetResult_$reflection()]]);
}

function SearchedItem$1__get_HasMatches(this$) {
    return exists((m) => equals(m.MatchType, new MatchType(0, [])), this$.SearchResult.Matches);
}

export function MultiSelect_MultiSelect_7DCB2536(multiSelect_MultiSelect_7DCB2536InputProps) {
    let elems_6;
    const searchMoreButtonProps = multiSelect_MultiSelect_7DCB2536InputProps.searchMoreButtonProps;
    const searchHighlighting = multiSelect_MultiSelect_7DCB2536InputProps.searchHighlighting;
    const searchCaseMatching = multiSelect_MultiSelect_7DCB2536InputProps.searchCaseMatching;
    const translations = multiSelect_MultiSelect_7DCB2536InputProps.translations;
    const readonly = multiSelect_MultiSelect_7DCB2536InputProps.readonly;
    const onSelect = multiSelect_MultiSelect_7DCB2536InputProps.onSelect;
    const onSearchTermChange = multiSelect_MultiSelect_7DCB2536InputProps.onSearchTermChange;
    const items = multiSelect_MultiSelect_7DCB2536InputProps.items;
    const key = multiSelect_MultiSelect_7DCB2536InputProps.$key;
    const patternInput = reactApi.useState("");
    const filterText = patternInput[0];
    const searchInputRef = reactApi.useRef(undefined);
    const search = Searcher_$ctor_Z1481DE65(new SearchConfig(empty({
        Compare: compare,
    }), defaultArg(searchCaseMatching, new CaseMatching(1, [])), defaultArg(searchHighlighting, new Highlighting(0, [])), Option_ofNonNullOrWhitespace(filterText)), translations);
    const searchedItems = toArray(sortBy((_arg_2) => _arg_2.Item.Text.toLocaleLowerCase(), map((item) => (new SearchedItem$1(toKebab(toText(interpolate("%A%P()", [item.Value]))), item, Searcher__Target_4B4D257A(search, item.SearchTarget, item.Text))), items), {
        Compare: comparePrimitives,
    }));
    const patternInput_1 = ($007CNullOrWhiteSpace$007C_$007C(filterText) != null) ? [false, searchedItems] : [searchedItems.every((x_3) => (x_3.Item.Text.toLocaleLowerCase() !== filterText.toLocaleLowerCase())), searchedItems.filter((x_4) => {
        if (x_4.Item.Selected ? true : SearchedItem$1__get_HasMatches(x_4)) {
            return true;
        }
        else {
            return !x_4.Item.Filterable;
        }
    })];
    const visibleItems = patternInput_1[1];
    const selectedValues = ofSeq(toList(delay_1(() => collect((item_1) => (item_1.Selected ? singleton(item_1.Value) : empty_1()), items))), {
        Compare: compare,
    });
    const toggle = (value, isChecked) => {
        const matchValue = FSharpSet__Contains(selectedValues, value);
        if (isChecked) {
            if (matchValue) {
            }
            else {
                onSelect([true, value]);
            }
        }
        else if (matchValue) {
            onSelect([false, value]);
        }
    };
    return createElement("div", createObj(Helpers_combineClasses("dropdown", ofArray([["key", key], ["className", join(" ", toList(delay_1(() => append(singleton("w-full"), delay_1(() => (readonly ? singleton("cursor-default") : singleton("cursor-pointer")))))))], (elems_6 = toList(delay_1(() => {
        let elems_1;
        return append(singleton(createElement("div", createObj(ofArray([["key", `${key}-content`], ["role", join(" ", ["button"])], ["tabIndex", 0], ["className", join(" ", toList(delay_1(() => append(singleton("input input-bordered w-full"), delay_1(() => append(singleton("flex items-center flex-wrap gap-2 h-auto min-h-11 px-1.5 py-2"), delay_1(() => (readonly ? singleton("bg-base-300") : empty_1()))))))))], ["onFocus", (_arg) => {
            JS_runAfter(150, () => {
                iterate((_arg_1) => {
                    _arg_1.focus();
                }, toArray_1(searchInputRef.current));
            });
        }], (elems_1 = toList(delay_1(() => collect((matchValue_2) => {
            const key_8 = matchValue_2.Key;
            const item_2 = matchValue_2.Item;
            return item_2.Selected ? singleton(createElement("div", createObj(Helpers_combineClasses("badge", toList(delay_1(() => append(singleton(["className", "badge-primary"]), delay_1(() => append(singleton(["className", "badge-soft"]), delay_1(() => append(singleton(["key", `${key_8}-badge`]), delay_1(() => append(singleton(["className", "gap-1"]), delay_1(() => append(!readonly ? singleton(["style", {
                paddingInlineEnd: 0,
            }]) : empty_1(), delay_1(() => {
                let elems;
                return singleton((elems = toList(delay_1(() => append(singleton(item_2.Text), delay_1(() => (!readonly ? singleton(createElement("button", createObj(Helpers_combineClasses("btn", ofArray([op_PlusPlus(["className", "btn-ghost"], ["className", "btn-circle"]), ["type", "button"], ["key", `${key_8}-remove-button`], ["tabIndex", -1], ["className", "text-[10px]"], ["style", {
                    "--size": "1.5rem",
                }], ["children", "✕"], ["onMouseDown", (e) => {
                    e.preventDefault();
                }], ["onClick", (_arg_3) => {
                    toggle(item_2.Value, false);
                }]]))))) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems))]));
            })))))))))))))))) : empty_1();
        }, searchedItems))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay_1(() => {
            let elems_5;
            return ((searchedItems.length > 0) && !readonly) ? singleton(createElement("ul", createObj(Helpers_combineClasses("dropdown-content", ofArray([["key", `${key}-dropdown-content`], ["tabIndex", -1], ["className", "bg-base-100 rounded-box z-1 w-64 p-0 shadow-sm"], (elems_5 = toList(delay_1(() => {
                let elems_2, $keyZ57CFA838;
                return append(singleton(createElement("li", createObj(ofArray([["key", `${key}-search`], ["className", "p-2"], (elems_2 = [($keyZ57CFA838 = (`${key}-search-input`), createElement(SearchBox_SearchBox_3A9FAC5, {
                    key: $keyZ57CFA838,
                    $key: $keyZ57CFA838,
                    value: filterText,
                    onChange: (searchTerm) => {
                        patternInput[1](searchTerm);
                        onSearchTermChange(new SearchInfo(searchTerm, patternInput_1[0]));
                    },
                    translations: translations,
                    inputRef: searchInputRef,
                    onKeyDown: (ev) => {
                        let onSearch;
                        let matchResult, onSearch_1;
                        if (searchMoreButtonProps != null) {
                            if (searchMoreButtonProps.tag === 1) {
                                if ((onSearch = searchMoreButtonProps.fields[2], ev.key === "Enter")) {
                                    matchResult = 0;
                                    onSearch_1 = searchMoreButtonProps.fields[2];
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0: {
                                ev.preventDefault();
                                onSearch_1();
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                    },
                    searchMoreButtonProps: unwrap(searchMoreButtonProps),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay_1(() => {
                    let checkBoxState, matchValue_3, matchValue_4, elems_3, $keyZ5D0B059D;
                    return append((searchedItems.length > 1) ? ((checkBoxState = ((matchValue_3 = (FSharpSet__get_Count(selectedValues) | 0), (matchValue_4 = (searchedItems.length | 0), (matchValue_3 === 0) ? (new CheckboxState(1, [])) : ((matchValue_3 === matchValue_4) ? (new CheckboxState(0, [])) : (new CheckboxState(2, [])))))), singleton(createElement("li", createObj(ofArray([["key", `${key}-select-all`], ["className", "text-primary border-b border-base-200"], (elems_3 = [($keyZ5D0B059D = (`${key}-select-all-checkbox`), createElement(Checkbox_Checkbox_Z1659CCBA, {
                        key: $keyZ5D0B059D,
                        $key: $keyZ5D0B059D,
                        state: checkBoxState,
                        children: singleton_1(toText(interpolate("%s%P() (%d%P())", [TranslationPages_Home__get_SelectedPlural(AppTranslations__get_Home(translations)), FSharpSet__get_Count(selectedValues)]))),
                        onCheck: (isChecked_1) => {
                            if (isChecked_1) {
                                iterate((_arg_4) => {
                                    const item_3 = _arg_4.Item;
                                    if (!item_3.Selected) {
                                        onSelect([true, item_3.Value]);
                                    }
                                }, visibleItems);
                            }
                            else {
                                iterate((value_53) => {
                                    onSelect([false, value_53]);
                                }, selectedValues);
                            }
                        },
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))))) : empty_1(), delay_1(() => map((item_4) => {
                        let elems_4;
                        return createElement("li", createObj(ofArray([["key", `${key}-select-${item_4.Key}`], ["className", "group flex items-center hover:bg-base-300 transition-colors"], (elems_4 = toList(delay_1(() => {
                            let $keyZ6FA0BBB8;
                            return append(singleton(($keyZ6FA0BBB8 = (`${key}-select-${item_4.Key}-checkbox`), createElement(Checkbox_Checkbox_Z1659CCBA, {
                                key: $keyZ6FA0BBB8,
                                $key: $keyZ6FA0BBB8,
                                state: CheckboxState_CheckedIf_Z1FBCCD16(item_4.Item.Selected),
                                children: singleton_1(Highlight_matches((children_2) => createElement("span", createObj(children_2)), singleton_1(["key", `${key}-select-${item_4.Key}-label`]), item_4.SearchResult)),
                                onCheck: curry2(toggle)(item_4.Item.Value),
                            }))), delay_1(() => {
                                const matchValue_6 = item_4.Item.Image;
                                if (matchValue_6 == null) {
                                    return empty_1();
                                }
                                else {
                                    return singleton(matchValue_6);
                                }
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                    }, visibleItems)));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
}

